import React, { useState, useEffect } from 'react';
// Images
import MainImage from '../../assets/images/main/miss-dominatrixa-pro-domme-bed-with-toys.webp';
import RealTimeImage from '../../assets/images/main/miss-dominatrixa-pro-domme-chained-up-sub.webp';
// Constants
import {
  LocationCountry,
} from '../../utils/Constants';
import {
  ABOUT_PAGE_URL,
  REAL_TIME_URL,
} from '../../utils/Routes';

function PlaySectionOne() {
  const [clipsImageSrc, setClipsImageSrc] = useState(MainImage);

  useEffect(() => {
    const updateImage = () => {
      setClipsImageSrc(window.innerWidth < 768 ? MainImage : MainImage);
    };

    updateImage(); // Set initial image
    window.addEventListener('resize', updateImage);

    return () => window.removeEventListener('resize', updateImage);
  }, []);

  const items = [
    {
      id: 1,
      title: 'Step Into My World',
      subtitle: (
        <>
          Enter my domain, where power, pleasure, and submission intertwine. I
          am <strong>Miss Dominatrixa</strong>, a sensual Goddess in{' '}
          {LocationCountry}, commanding adoration, devotion, and absolute
          obedience. My passion for polish and latex is more than
          indulgence—it's a manifestation of my power. Are you brave enough to
          kneel and worship at my feet? 💋
        </>
      ),
    },
    {
      id: 2,
      title: 'About Miss Dominatrixa',
      subtitle:
        'Discover my authority, power, and the intoxicating world I rule.',
      image: clipsImageSrc,
      link: ABOUT_PAGE_URL,
    },
    {
      id: 3,
      title: 'Real Time Sessions',
      subtitle: 'Exclusive sessions for the truly devoted. Are you worthy?',
      image: RealTimeImage,
      link: REAL_TIME_URL,
    },
  ];

  return (
    <section className='lg:container mx-auto px-6 sm:px-10 md:px-20 mt-2 lg:mt-0 lg:px-12'>
      {/* Title */}
      <section className='grid grid-cols-reg w-full gap-x-6 mb-4'>
        {/* Large screen */}
        <div className='hidden md:grid items-center'>
          <h4 className='text-3xl neon_text_thin font-titleFont tracking-widest'>
            Obey & Explore
          </h4>
        </div>
        {/* Phone screen */}
        <div className='grid md:hidden items-center'>
          <h4 className='text-2xl neon_text_thin font-titleFont tracking-widest'>
            Obey & <br /> Explore
          </h4>
        </div>
        <div className='grid items-center'>
          <div
            className='h-[2px] -mb-1 bg-colour3'
            role='separator'
            aria-hidden='true'
          ></div>
        </div>
      </section>

      {/* Main */}
      <section className='grid lg:grid-cols-3 gap-10 lg:gap-8'>
        {/* Render the first item as a text box */}
        <article className='grid grid-rows-reg bg-colour4 dark:bg-colour4 text-colour5 dark:text-colour5 px-6 py-8 rounded-lg shadow-cardShadow shadow-colour3 text-center'>
          <div className='h-fit border-b-2 border-solid border-colour5 mx-2 pb-2'>
            <h5 className='font-titleFont font-semibold text-2xl lg:text-3xl '>
              {items[0].title}
            </h5>
          </div>
          <div className='text-center my-auto pt-4'>
            <p className='mt-2'>{items[0].subtitle}</p>
          </div>
        </article>

        {/* Render the remaining items as links with images */}
        {items.slice(1).map((item) => (
          <a
            href={item.link}
            key={item.id}
            className='border-b-2 grid grid-rows-rev pb-4 border-solid border-colour4 group'
          >
            <img
              src={item.image}
              alt={item.title}
              className='w-full h-full object-cover shadow-cardShadow shadow-colour4 max-h-[70vh] lg:max-h-[50vh] rounded-md transition-transform duration-500 group-hover:scale-105'
              loading='lazy'
            />
            <div className='h-fit'>
              <h5 className='text-colour3 dark:text-colour3 text-xl font-titleFont mt-3 lg:mt-4 font-semibold'>
                {item.title}
              </h5>
              <p className='play-subtitle'>{item.subtitle}</p>
            </div>
          </a>
        ))}
      </section>
    </section>
  );
}

export default PlaySectionOne;
